import React, { useContext } from "react";
import { ParallaxLayer } from "@react-spring/parallax";
import CustomButton from "../../ui/CustomButton";
import AnimatedNumber from "../../../utilz/animatedNumber";
import { getAboutLayerOffset, getAboutLayerSpeed } from "./utilz/layerSpeeds";
import { DataContext } from "../../../context/data.context";
import { a } from "@react-spring/web";
interface AboutContentProps {
	offset: number;
	isFirstVisit: boolean;
	integrationCount: number;
	onShowModal: () => void;
}

export const AboutContent: React.FC<AboutContentProps> = ({ offset, isFirstVisit, integrationCount, onShowModal }) => {
	const layerOffset = isFirstVisit ? getAboutLayerOffset(offset, "text") : 0;
	const layerSpeed = isFirstVisit ? getAboutLayerSpeed("text") : 0;
	const { meta } = useContext(DataContext);
	const getMetaValue = (key: string) => 
		meta?.find((meta) => meta.attributes.key === key)?.attributes.value;
	const getMetaValueLong = (key: string) => 
		meta?.find((meta) => meta.attributes.key === key)?.attributes.valueLong;

	const holders = getMetaValue("HOLDERS");
	const chains = Number(getMetaValue("CHAINS"));
	const aboutText = getMetaValueLong("ABOUT");

	return (
		<ParallaxLayer
			key={`About-Text-${offset}-${isFirstVisit}`}
			offset={layerOffset}
			speed={layerSpeed}
			style={{ zIndex: 16 }}
		>
			<div
				className={`about-section ${isFirstVisit ? "about-fade-in" : ""}`}
				style={{ overflow: "hidden" }}
			>
				<div style={{ display: "flex", alignItems: "center", gap: 10, borderStyle: "solid", borderWidth: 0, borderColor: "white" }}>

					<h2>ABOUT BONK</h2>
					<img src='/images/bonk-logo.png' style={{height: 80}} alt="Bonk Logo" className="bonk-logo" />
				</div>
				<p>
					{aboutText}	 
				</p>
				<CustomButton
					text="OUR STORY"
					onClick={onShowModal}
				/>

				<div className="stats">
					<div>
						{/* {isFirstVisit ? (
							<AnimatedNumber
								number={914}
								duration={2}
								decimals={0}
								suffix="K"
								className="animated-number"
							/>
						) : (
							<strong>921K</strong>
						)} */}
						<strong>{holders}</strong>
						<span>HOLDERS</span>
					</div>
					<div>
						{isFirstVisit ? (
							<AnimatedNumber
								number={integrationCount}
								duration={2}
								decimals={0}
								className="animated-number"
							/>
						) : (
							<strong>{integrationCount}</strong>
						)}
						<span>INTEGRATIONS</span>
					</div>
					<div>
						{isFirstVisit ? (
							<AnimatedNumber
								number={13}
								duration={2}
								decimals={0}
								className="animated-number"
							/>
						) : (
							<strong>{chains}</strong>
						)}
						<span>CHAINS</span>
					</div>
				</div>
			</div>
		</ParallaxLayer>
	);
};
